import { getCountry } from "../../../common/userfuctions";
import { post } from "../https";

const SERVER_URL = process.env.REACT_APP_HIRE_SIDE_API;

export const GetAIUsage = (
  AccessToken = "",
  moreParams={}
) => {
    const country = getCountry();
  let params = {
    r: "AIUsage",
    rt: "GetAIUsage",
    p: JSON.stringify({
      AccessToken: AccessToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params, moreParams);
};